import { defineStore } from "pinia";
import { Mate, Story } from "@/types/entity";
import api from "@/modules/api";
import { nextTick } from "vue";

export const useHome = defineStore("home", {
  state: () => ({
    data: {
      galGamezz: {
        hot: [] as GalGame[],
        latest: [] as GalGame[],
      },
      matezz: {
        hotFanswork: [] as Mate[],
        hotOriginal: [] as Mate[],
        latestFanswork: [] as Mate[],
        latestOriginal: [] as Mate[],
      },
      storyzz: {
        hot: [] as Story[],
        latest: [] as Story[],
      },
    },
    activeOriginal: "hot" as "hot" | "latest",
    activeFanswork: "hot" as "hot" | "latest",
    activeGalgame: "hot" as "hot" | "latest",
    activeStory: "hot" as "hot" | "latest",

    recommendedList: [] as Mate[],
    isInit: false,
    isFetching: false,
    scrollTopCache: 0,

    cursor: undefined as string | undefined,

    showAddModal: false,
  }),
  getters: {
    originalList(state) {
      return state.data.matezz[
        (state.activeOriginal + "Original") as "hotOriginal" | "latestOriginal"
      ];
    },
    fansworkList(state) {
      return state.data.matezz[
        (state.activeFanswork + "Fanswork") as "hotFanswork" | "latestFanswork"
      ];
    },
    gameList(state) {
      return state.data.galGamezz[state.activeGalgame];
    },
    storyList(state) {
      return state.data.storyzz[state.activeStory];
    },
  },
  actions: {
    fetchRecommended(isReload = false): Promise<boolean> {
      return new Promise(async (resolve) => {
        let { cursor } = this;
        if (isReload) cursor = undefined;
        const { list, nextCursor } = await api.readRecommended({
          pagination: { perPage: 6 },
          cursor,
        });
        this.cursor = nextCursor;
        if (isReload) this.recommendedList = [];
        this.recommendedList = [
          ...this.recommendedList,
          ...list.map((v: { item: any; type: number }) => {
            const { item, type } = v;
            let obj = this.getDataByTypeAndItem(type, item);
            return {
              ...obj,
              type,
            };
          }),
        ];

        setTimeout(() => {
          resolve(true);
        }, 500);
      });
    },
    getDataByTypeAndItem(type: number, item: any) {
      let obj: any = { key: String(type) + String(item.id) };
      if (type === 1) {
        // Mate
        const { mediaUrl, gender, name, bio, uuid, isNsfw } = item;
        obj.src = mediaUrl;
        obj.gender = gender;
        obj.ratio = "3/4";
        obj.title = name;
        obj.description = bio;
        obj.url = `/mate/${uuid}`;
        obj.isNsfw = isNsfw;
      } else if (type === 2) {
        // Moment
        const { mediazz, mate, text, uuid } = item;
        if (mediazz?.length > 0) {
          const { url, width, height, mineType } = mediazz[0];
          obj.src = url;
          obj.ratio = `${width}/${height}`;
          if (mineType && mineType.split("/")[0] === "video") {
            obj.mineType = "video";
          }
        }
        const { mediaUrl, gender, name } = mate;
        if (!obj.src) obj.src = mediaUrl;
        obj.gender = gender;
        obj.title = name;
        obj.description = text;
        obj.url = `/thread/${uuid}`;
      } else if (type === 3) {
        // Story
        const { title, description, uuid, media } = item;
        if (media) {
          const { url, width, height } = media;
          obj.src = url;
          obj.ratio = `${width}/${height}`;
        }
        obj.title = title;
        obj.description = description;
        obj.url = `/story/read/${uuid}`;
      } else if (type === 4) {
        // Game
        const { name, description, coverMedia, uuid } = item;
        if (coverMedia) {
          const { url, width, height } = coverMedia;
          obj.src = url;
          obj.ratio = `${width}/${height}`;
        } else {
          obj.ratio = "16/9";
        }
        obj.title = name;
        obj.description = description;
        obj.url = `/game/${uuid}`;
      }
      return obj;
    },
    async initHome(force?: boolean) {
      if (this.isInit && !force) return;
      this.data = await api.readPopular();
      this.isInit = true;
      // this.fetchRecommended();
    },
  },
});
